import { render, staticRenderFns } from "./SupportingDocumentsSection.vue?vue&type=template&id=517fc20b&scoped=true&"
import script from "./SupportingDocumentsSection.vue?vue&type=script&lang=js&"
export * from "./SupportingDocumentsSection.vue?vue&type=script&lang=js&"
import style0 from "./SupportingDocumentsSection.vue?vue&type=style&index=0&id=517fc20b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517fc20b",
  null
  
)

export default component.exports